<template>
  <ContextMenu :id="id" :items="mobile ? mobileMenu : menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";
import CancelEnrollmentModal from "./CancelEnrollmentModal";
import AddToLearningPathModal from "../LearningPaths/AddToLearningPathModal";
import ExtendEnrollmentModal from "./ExtendEnrollmentModal";
import UpdateNateModal from "./UpdateNateModal";
import PrerequisiteNotice from "components/pages/registration/partials/PrerequisiteNotice";

export default {
  mixins: [ContextMenuMixin],

  props: {
    mobile: { type: Boolean, default: false },
    section: { type: String, default: "training" },
  },

  computed: {
    routeParam() {
      return { enrollment: this.item.id };
    },

    menu() {
      let menu = [];

      if (this.section == "admin") {
        menu.push({
          label: "View User Details",
          action: () => {
            this.goToRoute("admin.users.edit", { user: this.item.user_id });
          },
        });
      } else {
        menu.push({
          label: "View User Details",
          action: () => {
            this.doAction("show-user-details");
          },
        });
      }

      menu.push({
        label: "View Course Details",
        action: () => {
          this.doAction("show-course-details");
        },
      });

      if (!!this.item.can_update && this.section == "admin") {
        menu.push({
          label: "Edit",
          action: () => {
            this.goToRoute("admin.courses.enrollments.edit", this.routeParam);
          },
        });
      }

      if (!!this.item.can_cancel && this.section == "admin") {
        menu.push({
          label: "Remove",
          action: () => {
            this.cancelEnrollment();
          },
        });
      }

      if (!!this.item.can_print_confirmation) {
        menu.push({
          label: "Purchase Confirmation",
          action: () => {
            this.goToRoute(
              "enroll.online.print.enrollment",
              this.routeParam,
              true
            );
          },
        });
      }

      if (!!this.item.can_print_certificate) {
        menu.push({
          label: "Print Certificate",
          action: () => {
            this.goToRoute(
              "training.courses.enrollments.certificate",
              this.routeParam,
              true
            );
          },
        });
      }

      if (this.item.user_id == this.$root.user.id) {
        if (
            !!this.item.enrollable.can_launch &&
            !!this.item.enrollable.launch_url
        ) {
          menu.push({
            label: "Launch",
            action: () => {
              this.goToUrl(this.item.enrollable.launch_url, true);
            },
          });
        } else if (!!this.item.enrollable.show_prereq_notice) {
          menu.push({
            label: "Launch",
            action: () => {
              this.showPrerequisiteNotice();
            },
          });
        }
      }

      if (!!this.item.can_update_nate) {
        var label = !!this.item.nate_id
            ? "Re-assign NATE ID"
            : "Add NATE ID";
        menu.push({
          label: label,
          action: () => {
            this.updateNateId();
          },
        });
      }

      if (!!this.item.can_add_to_path && this.section == "admin") {
        var label = !!this.item.learning_path_enrollment_id
          ? "Re-assign Learning Path"
          : "Add to Learning Path";

        menu.push({
          label: label,
          action: () => {
            this.addToLearningPath();
          },
        });
      }

      if (!!this.item.can_extend_enrollment && this.section == "admin") {
        menu.push({
          label: "Extend Enrollment",
          action: () => {
            this.extendEnrollment();
          },
        });
      }

      menu.sort(this.sortMenu);

      return menu;
    },

    mobileMenu() {
      let menu = [
        {
          label: "View User Details",
          action: () => {
            this.goToRoute("training.users.show", { user: this.item.user_id });
          },
        },
        {
          label: "View Course Details",
          action: () => {
            this.goToRoute("catalog.course", {
              course: this.item.enrollable_id,
            });
          },
        },
      ];

      if (!!this.item.can_print_confirmation) {
        menu.push({
          label: "Purchase Confirmation",
          action: () => {
            this.goToRoute(
              "enroll.online.print.enrollment",
              this.routeParam,
              true
            );
          },
        });
      }

      if (!!this.item.can_print_certificate) {
        menu.push({
          label: "Print Certificate",
          action: () => {
            this.goToRoute(
              "training.courses.enrollments.certificate",
              this.routeParam,
              true
            );
          },
        });
      }

      if (
        !!this.item.enrollable.can_launch &&
        !!this.item.enrollable.launch_url
      ) {
        menu.push({
          label: "Launch",
          action: () => {
            this.goToUrl(this.item.enrollable.launch_url, true);
          },
        });
      } else if (!!this.item.enrollable.show_prereq_notice) {
        menu.push({
          label: "Launch",
          action: () => {
            this.showPrerequisiteNotice();
          },
        });
      }

      menu.sort(this.sortMenu);

      return menu;
    },
  },

  methods: {
    addToLearningPath() {
      this.$modal(AddToLearningPathModal, { enrollment: this.item })
        .then((response) => {
          this.eventBus.$emit("refresh");
        })
        .catch(() => {});
    },
    updateNateId() {
      this.$modal(UpdateNateModal, { enrollment: this.item })
          .then((response) => {
            this.eventBus.$emit("refresh");
          })
          .catch(() => {});
    },
    cancelEnrollment() {
      this.$modal(CancelEnrollmentModal, { enrollment: this.item })
        .then(() => {
          this.eventBus.$emit("refresh");
        })
        .catch(() => {});
    },
    extendEnrollment() {
      this.$modal(ExtendEnrollmentModal, { enrollment: this.item })
          .then((response) => {
            this.eventBus.$emit("refresh");
          })
          .catch(() => {});
    },

    showPrerequisiteNotice() {
      this.$modal(PrerequisiteNotice)
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>